import { HealthcareFacilityLocation } from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { commonTranslationKeys } from '@dreryk/react-common';
import { AutoLayout, Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../../translations';
import { HealthcareBasicData } from '../../../common/HealthcareBasicData';
import { HealthcareParentBasicDataPanel } from '../../../common/HealthcareParentBasicDataPanel';

import { HealthcareFacilityLocationUpdateForm } from './form/HealthcareFacilityLocationUpdateForm';
import { HealthcareFacilityLocationUpdateFormLoader } from './form/HealthcareFacilityLocationUpdateForm.loader';
import { HealthcareFacilityLocationUpdateModalConfirmButton } from './HealthcareFacilityLocationUpdateModalConfirmButton';

type HealthcareFacilityLocationUpdateModalProps = {
   readonly onCancel: VoidFunction;
   readonly healthcareFacilityLocationId: HealthcareFacilityLocation['id'];
   readonly healthcareParentData: HealthcareBasicData;
   readonly onDataChanged: VoidFunction;
};

export const HealthcareFacilityLocationUpdateModal = (
   props: HealthcareFacilityLocationUpdateModalProps
): JSX.Element => {
   return (
      <Modal
         title={healthcareOrganizationTranslationKeys.editHealthcareFacilityLocationData}
         onCloseRequest={props.onCancel}
         animateVisibility
         width={ModalWidth.WIDE}
         testId={'HealthcareFacilityLocationUpdate'}
         shouldCloseOnEsc={false}
         shouldCloseOnOverlayClick={false}
         visible
      >
         <AutoLayout as={'div'} $direction={'vertical'} $spacing={36} $horizontalResizing={'fill'}>
            <HealthcareParentBasicDataPanel
               testId={'healthcareFacilityUnitBasicData'}
               healthcareParentData={props.healthcareParentData}
               header={healthcareOrganizationTranslationKeys.healthcareFacilityUnitParentData}
            />
            <HealthcareFacilityLocationUpdateFormLoader
               healthcareFacilityLocationId={props.healthcareFacilityLocationId}
            >
               {({ healthcareFacilityLocation }) => (
                  <HealthcareFacilityLocationUpdateForm
                     healthcareFacilityLocation={healthcareFacilityLocation}
                     healthcareParentData={props.healthcareParentData}
                  >
                     {({ handleSubmit, formState, setLocationCodeNotUniqueErrorMessage }) => (
                        <>
                           <HealthcareFacilityLocationUpdateModalConfirmButton
                              handleSubmit={handleSubmit}
                              setLocationCodeNotUniqueErrorMessage={setLocationCodeNotUniqueErrorMessage}
                              onDataChanged={props.onDataChanged}
                           />
                           <ModalCancelButton
                              label={commonTranslationKeys.cancel}
                              onClick={props.onCancel}
                              shouldConfirmExit={formState.isDirty}
                           />
                           <ModalCloseButton onClick={props.onCancel} shouldConfirmExit={formState.isDirty} />
                        </>
                     )}
                  </HealthcareFacilityLocationUpdateForm>
               )}
            </HealthcareFacilityLocationUpdateFormLoader>
         </AutoLayout>
      </Modal>
   );
};
